// Supabase configuration using Environment Variables for Cloudflare Pages
// Fallback to hardcoded values for local development
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://rtfefxghfbtirfnlbucb.supabase.co';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ0ZmVmeGdoZmJ0aXJmbmxidWNiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA1MDg3OTcsImV4cCI6MjA1NjA4NDc5N30.fb7_myCmFzbV7WPNjFN_NEl4z0sOmRCefnkQbk6c10w';

// ImgBB API Key for photo uploads
export const IMGBB_API_KEY = import.meta.env.VITE_IMGBB_API_KEY || '48f280572c6df16576751c46e4e0c275';

// Cloudflare D1 Credentials
export const CF_ACCOUNT_ID = import.meta.env.VITE_CF_ACCOUNT_ID || 'e250e6d5d37a312c81e7aefa112c5f73';
export const CF_D1_DATABASE_ID = import.meta.env.VITE_CF_D1_DATABASE_ID || '9ef6adb7-6150-4bfd-ae7a-f4fc8fba6022';
export const CF_API_TOKEN = import.meta.env.VITE_CF_API_TOKEN || 'cfat_Ffn85toHqLJySNMsi0eSR8AXpFrFdGCMx4BUmRkv2115fee0';

